import type { FrameProps } from "@/components/shapes/shared/frame-props";
import { cardPaint } from "../shared/card-paint";
import { FrameEmptyState } from "../shared/frame-empty-state";
import { ObjectFrame } from "../shared/object-frame";
import { WeatherFace } from "./weather-face";
import { hasWeather, weatherFields } from "./weather-fields";
import { useT } from "@/i18n";
import { weatherFrameMessages } from "@/i18n/messages/frames-weather";

/** Weather: its card, larger, with each day's sky and low. */
export function WeatherFrame({ id, data }: FrameProps) {
  const t = useT(weatherFrameMessages);
  const fields = weatherFields(data.content ?? {});
  return (
    <ObjectFrame id={id} paint={cardPaint(data)} testId="weather-frame">
      {hasWeather(fields) ? (
        <WeatherFace
          fields={fields}
          density="regular"
          opened
          testIdPrefix="weather-frame"
        />
      ) : (
        <FrameEmptyState
          frameId={id}
          status={data.status}
          testId="weather-frame-empty"
        >
          {t("noWeather")}
        </FrameEmptyState>
      )}
    </ObjectFrame>
  );
}
